"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ToolCallSummary } from "@/types/call";
import { CallDetail, SuggestedMessage } from "@/types/chat";
import { MessageSummary } from "@/types/message";
interface UseSuggestionDisplayOptions {
  messages: (MessageSummary | CallDetail)[];
  lastPatientMessage: MessageSummary | CallDetail | undefined;
  displaySuggestion: boolean;
}
interface UseSuggestionDisplayReturn {
  suggestion: SuggestedMessage | ToolCallSummary | undefined;
  setSuggestion: (suggestion: SuggestedMessage | ToolCallSummary | undefined) => void;
}
export function useSuggestionDisplay(t0) {
  const $ = _c(10);
  const {
    messages,
    lastPatientMessage,
    displaySuggestion
  } = t0;
  const [suggestion, setSuggestion] = useState();
  let t1;
  if ($[0] !== displaySuggestion || $[1] !== lastPatientMessage) {
    t1 = () => {
      if (displaySuggestion && lastPatientMessage) {
        const lastPatientMessageSummary = lastPatientMessage as MessageSummary;
        const suggestedMessages = lastPatientMessageSummary.suggestedMessages || [];
        const toolCalls = lastPatientMessageSummary.toolCalls || [];
        const mostRecentSuggestion = [...suggestedMessages, ...toolCalls].filter(_temp).filter(_temp2).sort(_temp3)[0];
        setSuggestion(mostRecentSuggestion);
      } else {
        setSuggestion(undefined);
      }
    };
    $[0] = displaySuggestion;
    $[1] = lastPatientMessage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== displaySuggestion || $[4] !== lastPatientMessage || $[5] !== messages) {
    t2 = [messages, lastPatientMessage, displaySuggestion];
    $[3] = displaySuggestion;
    $[4] = lastPatientMessage;
    $[5] = messages;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = newSuggestion => {
      setSuggestion(newSuggestion);
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSetSuggestion = t3;
  let t4;
  if ($[8] !== suggestion) {
    t4 = {
      suggestion,
      setSuggestion: handleSetSuggestion
    };
    $[8] = suggestion;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp3(a, b) {
  return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
}
function _temp2(s_0) {
  return !("toolName" in s_0 && s_0.toolName === "NoResponse");
}
function _temp(s) {
  return !("isArchived" in s && s.isArchived);
}